import Vue from 'vue';
import './../../scss/layouts/_careers.scss';
// Plugins
import Router from 'vue-router';
import VueI18n from 'vue-i18n';

// Components
import App from '../vue/careers/App.vue';
import Index from '../vue/careers/components/Index.vue';
import Single from '../vue/careers/components/Single.vue';
import JobPost from '../vue/careers/components/JobPost.vue';
import NotFound from '../vue/careers/components/NotFound.vue';

export default function () {
    if (process.env.NODE_ENV !== 'production') {
        Vue.config.devtools = true;
        Vue.config.productionTip = false;
    }

    const getBasePath = () => {
        if (window.careers_data.locale === 'en') {
            return '/careers/open-positions';
        }
        const path = window.location.pathname;
        if (path.startsWith('/jp-refresh')) {
            return '/jp-refresh/careers/open-positions';
        }
        return '/jp/careers/open-positions';
    };

    Vue.use(Router);
    const router = new Router({
        mode: 'history',
        base: getBasePath(),
        routes: [
            { path: '/', name: 'index', component: Index },
            {
                path: '/job/:id',
                component: Single,
                props: true,
                children: [
                    { path: '', name: 'job-post', component: JobPost, props: true },
                ],
            },
            { path: '/404', name: 'not-found', component: NotFound, props: true },
            { path: '*', component: Index, props: { notFound: true } },
        ],
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition;
            } else {
                // Cancel window scroll for filter updates
                if (to.query.hasOwnProperty('department') || to.query.hasOwnProperty('locations') || to.fullPath === '/') {
                    return false;
                }
                // Scroll to top of the page on regular route changes
                return { x: 0, y: 0 };
            }
        },
    });

    Vue.use(VueI18n);

    // Create VueI18n instance with options
    const i18n = new VueI18n({
        locale: 'default',
        fallbackLocale: 'default',
        silentFallbackWarn: true,
        messages: window.translation_data.dictionary,
    });

    new Vue({
        el: '#careers',
        router: router,
        i18n,
        data: {
            source: window.careers_data,
        },
        render: h => h(App),
    });
}
